/* Component Dependencies */
var enrollmentTemplate = require('templates/enrollmentForm.hbs');
var enrollmentTemplateAssociate = require('templates/enrollmentForm-associate.hbs');
//This is the enrollment form for one click join on check in confirmation.
var enrollmentOcjTemplate = require('templates/enrollmentForm-oneClickJoin.hbs');
//This is the enrollment form for one click join on confirmation page.
var enrollmentOcjcpTemplate = require('templates/enrollmentForm-oneClickJoinConfirmationPage.hbs');
//This is the enrollment form for one click join - Save Password Modal from Reservation Lookup
var enrollmentOcjsrTemplate = require('templates/enrollmentForm-oneClickJoinAndSaveReservation.hbs');
//This is the enrollment form earn while you sleep modal for one click join on upcoming reservation page.
var enrollmentEarnWhileYouSleepTemplate = require('templates/enrollmentForm-earnWhileYouSleep.hbs');
//This is enrollmentFormVersion2 variation testing
var enrollmentFormVersionTwoTemplate = require('templates/enrollmentForm-v2.hbs');
var AriesComponent = require('libs/aries-component');
var passwordValidation = require('utils/passwordValidation.js');
var toggleFormFields = require('rewards_libs/toggleFormFields');
var Popup = require('libs/popup');
var emailValidationHandler = require('utils/emailValidation.js');
var sendVerificationHandlerFile = require('utils/sendVerificationCode.js');
var hiddenInputsHandler = require('utils/updateHiddenInputs');
AriesComponent.create({
  type: 'enrollmentForm',
  template: {
    'enrollmentForm': enrollmentTemplate,
    'enrollmentForm-associate': enrollmentTemplateAssociate,
    'enrollmentForm-oneClickJoin': enrollmentOcjTemplate,
    'enrollmentForm-oneClickJoinConfirmationPage': enrollmentOcjcpTemplate,
    'enrollmentForm-oneClickJoinAndSaveReservation': enrollmentOcjsrTemplate,
    'enrollmentForm-earnWhileYouSleep': enrollmentEarnWhileYouSleepTemplate,
    'enrollmentForm-v2':enrollmentFormVersionTwoTemplate
  },
  subscribe: {
    'FACEBOOK_LOGIN_POPULATE_ENROLLMENT_FORM': 'populateEnrollmentForm',
    'ADJUST_SELECT_WIDTH': 'adjustSelectWidth',
    'CHECK_AGREE_ALL': 'getSelectCountKRCheckboxes',
    'SUBMIT_ENROLL_FORM': 'submitCreateAccount',
    'TOGGLE_JOIN_BTN': 'disableSubmitButton'
  },
  events: {
    'change .js-consent-all':'toggleAllCheckboxes',
    'change .js-common-checkbox-class': 'checkAllToggleMethod',
    'click .js-optional-checkboxes a': 'termsConsenthandler',
    'click .js-required-checkboxes a': 'termsConsenthandler',
    'click .js-no-thanks-button': 'closePopup'
  },
  bindEvents: function ($) {
    var _self = this,
      confirmPassswordText = this.$el.find('.js-field-password-confirmation'),
      checkedCheckBoxesLength = _self.$el.find('.js-common-checkbox-class:checked').length,
      passwordValidationOptions = {
        isLabelIcon: false,
        passwordModuleSelector: '.js-password-info',
        passwordIconSelector: '.js-field-password + .t-icon',
        confirmPasswordIconSelector: '.js-field-password-confirmation + .t-icon',
        errorClasses: 't-icon-cross',
        successClasses: 't-icon-check'
      };
    var rfpFlowVal = this.$el.find('input[name="isRfpFlow"]').val();
    var irfpFlowVal = this.$el.find('input[name="isIrfpFlow"]').val();
    // _self.pubsub.publish('RFP_FLOW',[rfpFlowVal,irfpFlowVal]);  
    _self.onPageLoad = true;
    _self.enableCountryConsent = Boolean(_self.$el.find("#enableCountryConsent").val());
    _self.isCnLocaleVal = this.$el.find('input[name="isCnLocale"]').val();
    _self.isMobileVerificationRequiredVal = this.$el.find('input[name="isMobileVerificationRequired"]').val();
    var isModalsQueryParam = this.$el.find('input[name="modalsQueryParam"]').val();
    _self.pubsub.publish('CN_LOCALE_MOBILE',[rfpFlowVal,irfpFlowVal,_self.isCnLocaleVal,_self.isMobileVerificationRequiredVal,isModalsQueryParam]);  
    
    var enrollmentFormNode = $(".tile-enrollment-form").closest("div.l-row");
    this.cnPersonalDataCheckbox = _self.$el.find('.js-label-MR-cn-personal-data');
    this.cnCrossBorderDataCheckbox = _self.$el.find('.js-label-MR-cn-crossborder-data');
    this.cnAgreeTermsLabel = _self.$el.find('.js-label-MR');
    this.submitBtn = $('.js-submit-button');
    enrollmentFormNode.addClass('overflow-x-hidden')
    _self.selectCountKRCheckboxes = parseInt(checkedCheckBoxesLength);
    
    //on enrollment submit page trigger korean consent popup
    if (!($('.js-communication-preference-kr').hasClass('is-hidden'))) {
      _self.koreanConsentTermsPopup();
    }
    
    //On click of send verfication code to trigger OTP
				$(_self.$el.find('.js-mobile-verification-required, .js-send-verification-code-btn')).on('click', sendVerificationHandlerFile.sendVerificationHandler.bind(_self));
    confirmPassswordText.prop('disabled', true).addClass('is-disabled');
    passwordValidation.initialize(this.$el, passwordValidationOptions);
    toggleFormFields.initialize(_self.$el);
    $(_self.submitBtn).hasClass('is-disabled t-cursor-default') && $(this.submitBtn).removeClass('is-disabled t-cursor-default');
    $(_self.$el.find('.js-btn-cn-domain')).length > 0 && _self.disableSubmitButton();
    $(_self.$el.find('.checkMobile')).on('click', _self.countryWithCodeMobilePhoneDropdown.bind(_self));
    $(_self.$el.find('.analytics-click')).on('click', _self.validation.bind(_self));
    // Using global reference of jquery so that events on custom select box work correctly
    $(_self.$el.find('.js-countries-list')).on('change', _self.getCommunicationPreferences.bind(_self));
    _self.countryCodeDropdownTabFunctionality(_self);
    $(_self.cnAgreeTermsLabel).on('change', _self.disableSubmitButton.bind(_self));
    $(_self.cnPersonalDataCheckbox).on('change', _self.disableSubmitButton.bind(_self));
    $(_self.cnCrossBorderDataCheckbox).on('change', _self.disableSubmitButton.bind(_self));
    $(_self.$el.find('.js-last-name , .js-first-name')).on('blur', _self.translateUserInfo.bind(_self));
    $(_self.$el.find('.js-last-name-eng, .js-first-name-eng')).on('blur', _self.preventAjaxCall.bind(_self));
    //Fro Enable and Disable Enter OTP button
    $(_self.$el.find('.js-mobile-verification-required, .js-otp-button-enable')).on('input change',_self.enableSendVerificationBtn.bind(_self));
    // For opening modals in Standard 2.0
    var $termsLinkContainer = _self.$el.find('.l-terms-link');
    var modalsQueryParam = $termsLinkContainer.data('modalsQueryParam');
    $termsLinkContainer.find('a').each(function () {
      var $link = $(this);
      var dataMfpSrc = $link.data('mfp-src');
      if (dataMfpSrc) {
        $link.attr('data-mfp-src', dataMfpSrc + modalsQueryParam);
      }
    });
    // Initializing popups present in the component
    var enrollmentFormPopup = new Popup({
      selector: '.tile-enrollment-form .js-enrollment-modal a',
      sourceBlock: '.modal-content',
      alternateCloseMarkup: true
    });
    var enrollmentFormSubDesPopup = new Popup({
      selector: '.js-apec-modal a, .js-account-checkbox-cn:not(.l-preferences-label) a',
      sourceBlock: '.modal-content',
      alternateCloseMarkup: true
    });
    enrollmentFormPopup.register();
    enrollmentFormSubDesPopup.register();
    var postalCode = _self.$el.find('.l-user-details-wrapper').data('postalCode');
    if(_self.$el.hasClass('tile-enrollment-form-ocj') && typeof postalCode === 'string' &&  postalCode != "") {
      var userInfo = _self.$el.find('.js-user-info'), hasNumber = /\d/;
      !hasNumber.test(postalCode) ? userInfo.text(userInfo.text().split(',').slice(0, -1).join()) : '';
    }
    hiddenInputsHandler.updateValue(_self.$el);
    _self.$el.find('.js-submit-button-ocj').on('click', function(event) {
      event.preventDefault();
      !_self.enableCountryConsent && _self.submitEnrollmentForm([]);
    });
    _self.onComponentBind = true;
    const e = new Event("change");
    const element = document.querySelector('.js-countries-list')
    _self.$el.find('.js-countries-list').length > 0 && element.dispatchEvent(e);
    // Start Web Inspect Vulnerabilities fixes
    var styleHead = '<style type="text/css" id="antiClickjack">body{display:none !important;}</style>';
    var scriptHead = document.createElement("script");
    scriptHead.type = "text/javascript";
    scriptHead.innerHTML = "if(self === top){ var antiClickjack = document.getElementById('antiClickjack'); antiClickjack.parentNode.removeChild(antiClickjack); } else { top.location = self.location; }";
    _self.$el.find('.js-field-password').parents('html').find('head').append(styleHead);
    _self.$el.find('.js-field-password').parents('html').find('head').append(scriptHead);
    // End Web Inspect Vulnerabilities fixes
  },
  refreshCountryConsent: function(){
    var _self = this;
    if(_self.onComponentBind){
      _self.countryCodeChange = false;
      _self.onComponentBind = false;
    }else {
      _self.countryCodeChange = true;
    }
    _self.pubsub.publish('COUNTRY_CONSENT',[_self.countryCode,_self.isCnLocaleVal,_self.countryCodeChange]);
  },
  /**
    * This function is used to make ajax call to submit form data
    * and passes response to ajaxCallbackHandler library for further process
    */
  submitEnrollmentForm: function _submitEnrollmentForm(checkboxes) {
    var _self = this,
      dataObj = _self.$el.serialize(),
      button = $('.js-submit-button');
    button.prop('disabled', true).addClass('is-disabled');
    let nodeVal = '';
    if (checkboxes.length > 0) 
    {
      checkboxes.map(elements=>{
        for (let node in elements){
          nodeVal+= `&${node}=`+ elements[node];
        }
      })
      dataObj=dataObj+nodeVal;
    }
    // POST CALL TO SUBMIT DATA
    _self.makeAjaxCall({
      method: 'POST',
      url: _self.$el.attr('action'),
      data: dataObj,
      contentType: 'application/x-www-form-urlencoded',
      success: function(data) {
        if ( data.redirect === true ) {
          window.location.href = data.nextStateURI;
          return false;
        } else {
          _self.pubsub.publish(['REFRESH_MESSAGE_BOX'],[data.messageIdentifier]);
          _self.refreshCountryConsent();
          var timer = setTimeout(function() {
            clearTimeout(timer);
            _self.refresh();
            button.prop('disabled', false).removeClass('is-disabled');
          }, 500);
        }
      }
    });
  },
  /**
   * This function is used to make ajax call for getting communication preferences for country
   * selected from drop down
   * @param {Object} event Event object is passed
   */
  getCommunicationPreferences: function _getCommunicationPreferences(event) {
    this.countryCode = $(event.target).val();
    if(this.countryCode == 'US') {
      $('.js-kr-country-perf').find('.third-party-email').addClass('is-hidden');
    }
    else {
      $('.js-kr-country-perf').find('.third-party-email').removeClass('is-hidden');
    }
    this.makeAjaxCall({
      url: this.$el.find('.js-countries-list').data('component-endpoint'),
      method: 'POST',
      data: JSON.stringify({
        'sessionToken': this.getSessionToken(),
        'context': {
          "country": $(event.target).val(),
          "rand": $("input[name='rand']").val()
        }
      }),
      success: _.bind(this.updateCommunicationPreferences, this)
    });
  },
  /**
   * This function is used to update communication preferences based on ajax response on change
   * of country
   * @param {Object} response Ajax response is passed
   */
  updateCommunicationPreferences: function _updateCommunicationPreferences(response) {
    let countryArr = ['CN', 'JP', 'KR', 'VN']; //countries in which consents are applicable
    var _self = this;
    _self.refreshCountryConsent();
    var communicationCountryConsent = response.component.data.form.formFields.communicationCountryConsent;
    var isKrSelected = response.component.data.countryCodeSelected == 'KR',
      isCnSelected = response.component.data.countryCodeSelected == 'CN',
      isApacCountry = response.component.data.isApacCountry,
      crossBorderDataCheck = communicationCountryConsent.CN.requiredConsents.crossBorderPersonalDataRequired.value,
      personalDataCheck = communicationCountryConsent.CN.requiredConsents.personalDataRequired.value,
      $krCountryPref = this.$el.find('.js-kr-country-perf'),
      $krCommunicationPref = this.$el.find('.js-communication-preference-kr');
      $cnCommunicationPref = this.$el.find('.js-communication-preference-cn');
      $cnAccountUpdateLabel = this.$el.find('.js-account-update-label-cn');
      $cnAccountUpdateSubLabel = this.$el.find('.js-account-update-sub-label-cn');
      $nonCnAccountUpdateCheckbox = this.$el.find('.js-account-checkbox-non-cn');
      $cnAccountUpdateCheckbox = this.$el.find('.js-account-checkbox-cn');
      $apacAccountUpdateCheckbox = this.$el.find('.js-account-checkbox-apac');
      $agreeTermsContent = this.$el.find('.js-agree-terms-label');
      $krOtherDomain = this.$el.find('.js-kr-other-domain');
      $krBorderTopHide = this.$el.find('.js-kr-border-none');

      var enrollmentFormNode = $(".tile-enrollment-form").closest("div.l-row");
      var isVietnamSchemaDisabled = response.component.data.isVietnamSchemaDisabled;
    $(this.cnAgreeTermsLabel).prop('checked', false);
    if (isKrSelected === true) {
      enrollmentFormNode.addClass('overflow-x-hidden');
      $krCountryPref.addClass('is-hidden');
      $cnCommunicationPref.is(':visible') && $cnCommunicationPref.addClass('is-hidden');
      $krCommunicationPref.removeClass('is-hidden');
      $krBorderTopHide.removeClass('t-border-top t-border-color-standard-110');
      $agreeTermsContent.addClass('is-hidden');
      _self.koreanConsentTermsPopup();
    } else if (countryArr.includes(_self.countryCode) && !isApacCountry) {
				$apacAccountUpdateCheckbox.addClass('is-hidden');
        _self.updatePropForInputCheckbox($apacAccountUpdateCheckbox, $cnAccountUpdateCheckbox);
        $krCommunicationPref.is(':visible') && $krCommunicationPref.addClass('is-hidden');
        $krCountryPref.is(':hidden') && $krCountryPref.removeClass('is-hidden');
        (!_self.enableCountryConsent && _self.countryCode == "CN") && $cnCommunicationPref.removeClass('is-hidden');
        if(_self.countryCode !== "JP" && isVietnamSchemaDisabled == false){
          $cnAccountUpdateLabel.removeClass('is-hidden');
          if(_self.countryCode !== "VN") {
            $cnAccountUpdateSubLabel.removeClass('is-hidden');
            $cnAccountUpdateCheckbox.removeClass('is-hidden');
            $nonCnAccountUpdateCheckbox.addClass('is-hidden');
            _self.updatePropForInputCheckbox($nonCnAccountUpdateCheckbox, $apacAccountUpdateCheckbox);
          } else {
            $cnAccountUpdateCheckbox.addClass('is-hidden');
            $cnAccountUpdateSubLabel.addClass('is-hidden');
            $nonCnAccountUpdateCheckbox.removeClass('is-hidden');
            _self.updatePropForInputCheckbox($cnAccountUpdateCheckbox, $apacAccountUpdateCheckbox);
          }
          $agreeTermsContent.addClass('is-hidden');
        } else {
          $cnAccountUpdateLabel.addClass('is-hidden');
          if($nonCnAccountUpdateCheckbox.hasClass('is-hidden')) {
            $cnAccountUpdateSubLabel.addClass('is-hidden');
            $cnAccountUpdateCheckbox.addClass('is-hidden');
            $nonCnAccountUpdateCheckbox.removeClass('is-hidden');
            _self.updatePropForInputCheckbox($cnAccountUpdateCheckbox, $apacAccountUpdateCheckbox);
          }
          $agreeTermsContent.removeClass('is-hidden');
        }
        personalDataCheck ?  _self.toggleCheckbox('.js-consent-personal', true) :  _self.toggleCheckbox('.js-consent-personal', false);
        crossBorderDataCheck ?  _self.toggleCheckbox('.js-consent-crossborder', true) :  _self.toggleCheckbox('.js-consent-crossborder', false);
        _self.checkEmailOptin(response);
        !_self.onPageLoad && (_self.isCnLocaleVal && _self.countryCode=="CN") && _self.countryWithCodeMobilePhoneDropdown();
    } else {
      if (enrollmentFormNode.hasClass('overflow-x-hidden'))
        {
          enrollmentFormNode.removeClass('overflow-x-hidden');
        }
      $krCountryPref.removeClass('is-hidden');
      $krCommunicationPref.addClass('is-hidden');
      $krBorderTopHide.addClass('t-border-top t-border-color-standard-110');
      _self.checkEmailOptin(response);
      $cnCommunicationPref.addClass('is-hidden');
					 $cnAccountUpdateSubLabel.addClass('is-hidden');
					 if(_self.countryCode !== "VN") {
								$cnAccountUpdateLabel.addClass('is-hidden');
						} else {
      		$cnAccountUpdateLabel.removeClass('is-hidden');
						}
      $cnAccountUpdateCheckbox.addClass('is-hidden');
      if (isApacCountry) {
        $nonCnAccountUpdateCheckbox.addClass('is-hidden');
        $apacAccountUpdateCheckbox.removeClass('is-hidden');
        _self.updatePropForInputCheckbox($nonCnAccountUpdateCheckbox, $cnAccountUpdateCheckbox);
      } else {
        $nonCnAccountUpdateCheckbox.removeClass('is-hidden');
        $apacAccountUpdateCheckbox.addClass('is-hidden');
        _self.updatePropForInputCheckbox($apacAccountUpdateCheckbox, $cnAccountUpdateCheckbox);
      }
      $agreeTermsContent.removeClass('is-hidden');
    }

    if (countryArr.includes(_self.countryCode) && isVietnamSchemaDisabled == false) {
      $krOtherDomain.addClass('is-hidden');
    } else {
      $krOtherDomain.removeClass('is-hidden');
    }
    _self.isCnLocaleVal && _self.disableSubmitButton();
    _self.onPageLoad = false;
  },
   /**
   * This function will update the "checked" property for the input tag whenever country is selected from dropdown
   * Ex: For APAC countries, we should not be getting "checked" property for remaining two checkboxes i.e; CN and non-APAC
  */
  updatePropForInputCheckbox: function _updatePropForInputCheckbox(ele1, ele2) {
    for(i = 0; i < ele1.length; i++) {
      let inputElement = document.getElementById(ele1[i].getAttribute('for'));
      let secondInputElement = document.getElementById(ele2[i].getAttribute('for'));
      $(inputElement).prop("checked", false);
      $(secondInputElement).prop("checked", false);
    }
  },
  toggleCheckbox: function toggleCheckbox(ele, value) {
    this.$el.find(ele).prop('checked', value);
  },
  /**
   * This function will check whether to check the consent or not
   */
  checkEmailOptin: function _checkEmailOptin(response) {
    var communicationPreferences =response.component.data.form.formFields.communicationPreferences;
    var emailOptIn = communicationPreferences.emailOptIn.value;
    var thirdPartyEmailOptIn = communicationPreferences.thirdPartyEmailOptIn.value;
    emailOptIn ? this.toggleCheckbox('.js-email-opt-in',true) : this.toggleCheckbox('.js-email-opt-in', false);
    thirdPartyEmailOptIn ? this.toggleCheckbox('.js-third-party-email-opt-in', true) : this.toggleCheckbox('.js-third-party-email-opt-in',false);
  },
  /**
     * This function is used to change the country code value on selecting one
     * from the list
     */
  countryWithCodeMobilePhoneDropdown: function _countryWithCodeMobilePhoneDropdown() {
    var _self = this,
        otpTransactionId = _self.$el.find('.js-otp-transactionId'),
        mobileVerificationRefuiredCountry = _self.$el.find(".js-countries-list");
    _self.otpTxnValue = otpTransactionId.val();
    _self.pubsub.publish('SEND_OTP_TXN_VALUE', [_self.otpTxnValue]);
    $(".custom-arrow-mobile").find("b").toggleClass('t-icon-arrow-up t-icon-arrow-down');
    $(".mobilePhoneDropdownList").slideToggle();
    $(".custom-arrow-mobile").toggleClass('custom-arrow-selected');
    $(".mobilePhoneDropdownList").on("click", "li", function () {

      var selectedValue = $(this).attr('value');          
      var selectedValueText = $(this).find("span").get(0).innerText;
      $('li').removeClass('t-selected');
      $(this).addClass('t-selected');
      _self.$el.find(".custom-arrow-mobile #mobile-telephone").html(selectedValueText);
      $("#mobilePhoneDropdownList").val(selectedValue);
      $(".custom-arrow-mobile b").removeClass("t-icon-arrow-up").addClass("t-icon-arrow-down");

      $('#field-country-prefix-code').hide();
      $(".custom-arrow-mobile").css("border-color", "lightgray");
      $(".mobilePhoneDropdownList").off("click");
      //checking for CN domain and enabling the form fields
      if (_self.isMobileVerificationRequired()) { // Checking the Mobile Verification is required or not
        if(_.includes(mobileVerificationRefuiredCountry.data("mapping").phoneRequired, selectedValue)){
          if(otpTransactionId.val() == '') { //Checking the OTP enabled mode and enabling the form fields
            _self.showOTPFlowFields();
          }
          else {
            $(".js-otp-flow-toggle-text").show();
            $(".js-otp-flow-hide-text").hide();
            $(".js-otp-flow-toggle,.js-otp-flow-toggle-pwd").prop("disabled",false).removeClass('is-disabled');                    
            $('.js-otp-flow-disable-checkbox').prop('checked',false);
            $('.js-select-consent').prop('checked',false);
            _self.toggleCheckbox('.js-email-opt-in', false);
            _self.toggleCheckbox('.js-third-party-email-opt-in',false);
            _self.submitBtn.prop("disabled", true);
          }
        }
        else{
          $(".js-otp-flow-toggle-text").hide();
          $(".js-otp-flow-hide-text").show();
          $(".js-otp-flow-toggle,.js-otp-flow-toggle-pwd").prop("disabled",false).removeClass('is-disabled');                     
        }  
    }     
    });
    $('body').click(function (evt) {
      if (evt.target.id == "div-custom-arrow-dropdown-button" || $(evt.target).closest('#div-custom-arrow-dropdown-button').length)
        return;
      else {
        $('body').off("click");
        $(".custom-arrow-mobile b").removeClass("t-icon-arrow-up").addClass("t-icon-arrow-down");
        $('#field-country-prefix-code').hide();
        $(".custom-arrow-mobile").css("border-color", "lightgray");
      }
    });
  },
  /**
   * This function is used to populate JoinNowEnrolmentForm
   * @param {Object} response Ajax response from /aries-auth/getEnrollmentInfo.comp is passed
   * @returns {boolean} Operation succeeded or not
   */
  populateEnrollmentForm: function _populateEnrollmentForm(result) {
    if (this.$el.find('input[name="isDacFlow"]').val() === 'false') {
      this.$el.find('#field-first-name').val(result.firstName).end()
        .find('#field-last-name').val(result.lastName).end()
        .find('#field-street1').val(result.address).end()
        .find('#field-city').val(result.city).end()
        .find('#field-postal').val(result.zip).end()
        .find('#field-telephone-number').val(result.phone).end()
        .find('#field-email').val(result.email);
      if (result.country) {
        this.$el.find('#field-country option[value = "' + result.country + '" ]').attr('selected', 'selected');
      }
      if (result.countryPrefixCode) {
        this.$el.find('#field-country-prefix-code option[value = "' + result.countryPrefixCode + '" ]').attr('selected', 'selected');
      }
    }
    //three parameters for linking                                    
    this.$el.find('input[name="socialUID"]').val(result.UID).end()
      .find('input[name="socialUIDTimestamp"]').val(result.signatureTimeStamp).end()
      .find('input[name="socialUIDSignature"]').val(result.uidSignature);
    //hide or show fb section in join now page
    this.pubsub.publish('LOGIN_INFO_MESSAGE_BOX', []);
  },
  /**
   * This function is used to enable the TAB functionality and keyboard actions for the country code dropdown
   */
  countryCodeDropdownTabFunctionality: function _countryCodeDropdownTabFunctionality(_self) {
    $('#containerDivCCPrefixCodeDropdown').on('blur',
      function (e) {
        $(this).removeClass('active');
        $(".custom-arrow-mobile b").removeClass("t-icon-arrow-up").addClass("t-icon-arrow-down");
        $('#field-country-prefix-code').hide();
        $(".custom-arrow-mobile").css("border-color", "lightgray");
      });
    $('#containerDivCCPrefixCodeDropdown').focusin(
      function (e) {
        $(".custom-arrow-mobile").css("border", "0.0625rem solid #0075d5");
        $(this).addClass('active');
      });
    var mobilePhoneDropdownList = $('.mobilePhoneDropdownList').find('.t-font-m');
    var index = -1;
    $("#containerDivCCPrefixCodeDropdown").keyup(function (e) {
      if (e.which == 38) {
        // Up-Arrow
        index--;
        // Check that we've not tried to select before the first item
        if (index < 0) {
          index = 0;
        }
        _self.changeSelection(index);
      }
      else if (e.which == 40) {
        // Down-Arrow
        index++;
        // Check that index is not beyond the last item
        if (index > mobilePhoneDropdownList.length - 1) {
          index = mobilePhoneDropdownList.length - 1;
        }
        _self.changeSelection(index);
      }
      else if (e.which == 27) {
        // Esc key
        index = -1;
        mobilePhoneDropdownList.removeClass('selected');
        $('#field-country-prefix-code').hide();
      }
      else if (e.which == 13) {
        // Enter key
        var count = 0;
        if (count == 0) {
          $('#div-custom-arrow-dropdown-button').click();
          count++;
        }
        if (index > -1) {
          if (mobilePhoneDropdownList.hasClass('selected')) {
            $('.mobilePhoneDropdownList').find('.selected').click();
            index = -1;
            count--;
            mobilePhoneDropdownList.removeClass('selected');
          }
        }
      }
    });


    $("#containerDivCCPrefixCodeDropdown").keydown(function (e) {
      if (e.which == 38 || e.which == 40 || e.which == 13) {
        e.preventDefault();
      }
    });
  },
  changeSelection: function _changeSelection(index) {
    var mobilePhoneDropdownList = $('.mobilePhoneDropdownList').find('.t-font-m');
    mobilePhoneDropdownList.removeClass('selected');
    mobilePhoneDropdownList.eq(index).addClass('selected');
    if ($('.selected').find('.l-float-right').position().top + $('.mobilePhoneDropdownList').height() >= $('.mobilePhoneDropdownList').scrollTop() + $('.mobilePhoneDropdownList').height()) {
      $('.mobilePhoneDropdownList').scrollTop($('.selected').find('.l-float-right').position().top + 50 - $('.mobilePhoneDropdownList').height() + $('.mobilePhoneDropdownList').scrollTop())
    }
    else if ($('.selected').find('.l-float-right').position().top + $('.mobilePhoneDropdownList').height() < $('.mobilePhoneDropdownList').scrollTop() + $('.mobilePhoneDropdownList').height()) {
      $('.mobilePhoneDropdownList').scrollTop(0 + $('.selected').find('.l-float-right').position().top + $('.mobilePhoneDropdownList').scrollTop())
    }
  },
  adjustSelectWidth: function _adjustSelectWidth() {
    var _self = this;
    setTimeout(function () {
      $(document).trigger('GLOBAL_ELEMENTS_REINIT.mi-select');
    }, 200);

  },

  validation: function _validation(e) {
    if (emailValidationHandler.emailValidation($('#field-email').val(), 'email')) {
      $('#email-validation').addClass('l-display-none');
    }
    else {
      $('#email-validation').removeClass('l-display-none');
      if ($('.tile-message-box')) {
        $('.tile-message-box').addClass('l-display-none');
      }
      e.preventDefault();
    }
  },
  // To check Mobile Verification Required
  isMobileVerificationRequired: function _isMobileVerificationRequired() {
    var _self = this;
    var mobileVerificationRefuired = _self.$el.find('.js-mobile-verification-required');
    return mobileVerificationRefuired.data('mobile-verification-refuired');
  },
  // To show OTP Flow required fields 
  showOTPFlowFields: function _showOTPFlowFields(){
    $(".js-otp-flow-toggle-text").show();
    $(".js-otp-flow-hide-text").hide();
    $(".js-otp-flow-toggle").prop("disabled",true).addClass('is-disabled');
    $(".js-otp-flow-toggle-clear").prop("disabled",true).addClass('is-disabled').val('').removeClass("is-error");          
    $(".js-password-info li").removeClass('t-form-success').addClass('t-form-error');
    $(".js-password-info li span.t-icon").removeClass('t-icon-check').addClass('t-icon-cross');
    $(".js-password-icon").removeClass('t-icon-check t-icon-cross');      
    $('.js-confirm-password-icon').removeClass('t-icon-cross t-icon-check');    
    $('.js-otp-flow-disable-checkbox').prop('checked',false);
    $('.js-select-consent').prop('checked',false);
    this.submitBtn.prop("disabled", true);
    $('.js-resend-code').addClass('l-resend-code');    
  },
  // To enable and disable send verification button
  enableSendVerificationBtn: function _enableSendVerificationBtn(event) {    
    var isEmpty = $('.js-field-number').val(), 
        _self = this,   
        CNCountry = $('input[name="countryPrefixCode"]'),
        mobileVerificationRefuiredCountry = _self.$el.find(".js-countries-list");
    if(_.includes(mobileVerificationRefuiredCountry.data("mapping").phoneRequired, CNCountry.val())){  
      _self.showOTPFlowFields();
      $('.tile-message-box').addClass('is-hidden');
      $('.js-otp-send-check').hide(); 
      $('.js-otp-transactionId').val('');
      $('.js-toggle-icon').removeClass('t-icon-cross');
      $('.js-toggle-error-exists').removeClass("is-error");           
      $('.js-custom-message-box').removeClass('is-hidden');
    }
    if (isEmpty != "") {
      $('.js-send-verification-code-btn').removeClass("is-disabled t-cursor-default").prop("disabled", false);
    } else {
      $('.js-send-verification-code-btn').addClass("is-disabled t-cursor-default").prop("disabled", true);
    }
  },  

  disableSubmitButton: function _disableSubmitButton(jsJoinBtn) {
    var joinBtn = jsJoinBtn;
    var _self = this;
    this.submitBtn = $('.js-submit-button');
    $(this.submitBtn).hasClass('is-disabled t-cursor-default') && $(this.submitBtn).removeClass('is-disabled t-cursor-default');
    if ($(this.cnAgreeTermsLabel).is(':visible')){
      var isChecked = $(this.cnAgreeTermsLabel).is(':checked');
      if (isChecked) {
        $(this.submitBtn).prop("disabled", false);
      } else {
        $(this.submitBtn).prop("disabled", true);
      }
    } else {
      let consentCheckboxes = $('.js-select-consent');
      let krRequiredConsents = $('.js-kr-required-consent');
      _self.allChecked = true;
      if (!joinBtn) {
        joinBtn = this.submitBtn;
      }
      if($('.js-communication-preference-kr').hasClass('is-hidden') == false){
        _self.enableJoinNowButton(krRequiredConsents);
      }else{
        _self.enableJoinNowButton(consentCheckboxes);
      }
      _self.allChecked ? $(joinBtn).prop("disabled", false) : $(joinBtn).prop("disabled", true);
      
    }
    
  },
  // making ajax calls to backend with user input 
  translateUserInfo: function _translateUserInfo(event) {
    var _self = this;
    var inputName = event.target.value;
    var targetEl = event.target;
    var fieldClass= '.'+targetEl.classList[0]+'-eng';
    if ((!_self.$el.find(fieldClass).hasClass('js-no-ajax')) && (_self.$el.find('.is-error').length === 0) && (inputName || inputName.length !== 0)) {
          var userInfo = {
            word: inputName
          }
          var translatorUrl = _self.$el.find('.js-last-name').data('url');
          var chineseCharactersPayload = {
            method: 'POST',
            url: translatorUrl,
            type: "application/json",
            data: JSON.stringify(userInfo),
            success: function(data) {
              this.updateEnglishName(data.result,targetEl);
            }.bind(this)
          };
         this.makeAjaxCall(chineseCharactersPayload);
    }
  },
  //receiving generated name and writing the response in english field
  updateEnglishName: function _updateEnglishName(userName, targetEl) {
    var _self = this;
    // writing received name value to eng field
    if ($(targetEl).hasClass('js-last-name')) {
      _self.$el.find('.js-last-name-eng').val(userName);
      _self.$el.find('.js-last-name-eng').attr('data-translated-name', userName);
    } else if ($(targetEl).hasClass('js-first-name')) {
      _self.$el.find('.js-first-name-eng').val(userName);
      _self.$el.find('.js-first-name-eng').attr('data-translated-name', userName);
    }
  },

  // preventing ajax calls if user  has manually edited the english name
  preventAjaxCall: function _preventAjaxCall(event) {
    var _self = this;
    var targetEl = event.target;
    if(targetEl.value !== $(targetEl).attr('data-translated-name')) {
      $(targetEl).addClass('js-no-ajax');
    }
  },
  /**
   * This function is to get the number of checked boxes
   * @param event
   */
  getSelectCountKRCheckboxes: function _toggleAllCheckboxes (event) {
    this.selectCountKRCheckboxes=this.$el.find('.js-common-checkbox-class:checked').length;
  },

  submitCreateAccount: function _submitCreateAccount (checkboxes) {
    var nodesString = "";
    var _self = this;
    var currentCompId = _self.$el.data('component-id');
    checkboxes.length > 0 && checkboxes.map(elements=>
      {
      for (let name in elements) {
        nodesString += `<input type="hidden" name=${name} value=${elements[name]} />`;
      }
    });
    
    if ($('.user-enrollment-form-ocj').length > 0) {
      if($(`form[data-component-id=${currentCompId}]`).length > 0) {
        $(`form[data-component-id=${currentCompId}]`).each(function(i,el)
          {
            $(el).find('.js-submit-button-ocj').click()
            _self.submitEnrollmentForm(checkboxes);
          });        
      }
    } else if ($('.tile-enrollment-form').length > 0) {
      $('.tile-enrollment-form').append(nodesString);
      $("#enroll-form-join").click();
    }
   
  },

  /**
   * This function is used to toggel checkall and unceckall checkbox
   * @param event
   */
  toggleAllCheckboxes: function _toggleAllCheckboxes (event) {
    var _self = this,button = $('.js-submit-button');
    var isChecked = $(event.target).prop('checked');
    var requiredCheckboxes = _self.$el.find('.js-required-checkboxes input[type=checkbox]');
    var optionalCheckboxes = _self.$el.find('.js-optional-checkboxes input[type=checkbox]');
    var allCheckBoxesLength = _self.$el.find('.js-common-checkbox-class').length;
    
    if (isChecked === true) {
      requiredCheckboxes.prop('checked', true);
      optionalCheckboxes.prop('checked', true);
      _self.selectCountKRCheckboxes = allCheckBoxesLength;
      button.prop('disabled', false)
    } else {
      requiredCheckboxes.prop('checked', false);
      optionalCheckboxes.prop('checked', false);
      _self.selectCountKRCheckboxes = 0;
      if(_self.isCnLocaleVal){
        button.prop('disabled', true);
        }
    }
  },
    /**
   * This function is used to toggle check/uncheck the master checkbox on the basis of other checkboxes
   * @param event
   */
  checkAllToggleMethod: function _checkAllToggleMethod (event) {
    var _self = this;
    var allCheckBoxesLength = _self.$el.find('.js-common-checkbox-class').length;
    var isCheckboxChecked = $(event.target).prop('checked');
    var masterCheckbox = _self.$el.find('.js-consent-all');
    var isRequiredConsentChecked = _self.$el.find('.js-kr-required-consent:checked');

    if (isCheckboxChecked === true) {
      _self.selectCountKRCheckboxes++;
      if (allCheckBoxesLength === _self.selectCountKRCheckboxes) {
        masterCheckbox.prop("checked", true);
      }
      if(isRequiredConsentChecked.length > 0 && _self.isCnLocaleVal){
        _self.disableSubmitButton();
      }
    } else {
      _self.selectCountKRCheckboxes--;
      if (allCheckBoxesLength !== _self.selectCountKRCheckboxes) {
        masterCheckbox.prop("checked", false);
      }
      if(_self.isCnLocaleVal){
        _self.disableSubmitButton();
        }
    }
  },

  /**
    * This function adds class popup-triggered to the consent checkbox 
    * for respective terms link clicked
    * @param {event} e 
    */
   termsConsenthandler: function _termsConsenthandler(e){
    $(e.currentTarget).addClass('popup-triggered');
   },

   /**
    * This function is triggered on click of terms for Korean consent 
    * checkbox the popup would be triggered
    */
   koreanConsentTermsPopup: function _koreanTermsPopup(){
      var termsConsentPopup = new Popup({
        selector: ".js-communication-preference-kr .mi-popover",
        sourceBlock: ".modal-content",
        alternateCloseMarkup: true,
        contentLoaded: function() {
          //Once the popup content loads - iterate through the consent checkbox and check which terms link
          //(associated with the consent checbox) was clicked through popup-triggered class and add
          //data-consent-checked to I AGREE button, so respective checkbox is checked on click on I AGree.
          $('.js-kr-terms-link').each(function() {
            if(($(this).hasClass('popup-triggered'))){
             var consentChecked = $(this).data('kr-consent')
             $(".js-agree-button").attr('data-consent-checked', consentChecked);
             $(this).removeClass('popup-triggered');
            }
         });
        }
      });
      termsConsentPopup.register();
   },

   closePopup: function _closePopup(){
    var _self = this;
    _self.pubsub.publish('POPUP_CLOSE');
   },
   /**
    * This function is triggered on click of required consent checkbox for Korean consent 
    * checkbox and enable/disable join now button
    */
  enableJoinNowButton: function _enableJoinNowButton (activeCheckbox) {
	  var _self = this;
	  var selectedCheckbox = activeCheckbox;
		selectedCheckbox.length > 0 ? selectedCheckbox.map(function(){
        if(!_self.allChecked) return 0;
        if ($(this).is(':checked')){
         _self.allChecked = true;
        } else {
         _self.allChecked = false;
        }
     }) : _self.allChecked = false;
  }

});
